import React, { useState, useEffect } from 'react';
import { Form, Button, FormGroup, Input, Label, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { authorizedPost } from './api-authorization/AuthorizedFetch';
import ResponseLabel from './ResponseLabel';

const availableActivities = [
  "Please don't call on me today",
  "I need someone to talk to",
  "I need more regulation"
];

export const DysregulatedResponseButton = ({ response, onClick }) => {
  const s = response.dysregulationResponse ? { text: 'View Response', buttonColor: 'secondary' } : { text: 'Respond', buttonColor: 'primary' };

  return (
      <Button size="sm" color={s.buttonColor} onClick={() => onClick(response)}>{s.text}</Button>
  )
}

const placeholderText = `(e.g.: Conferenced with student, emailed or called home, or referred student to counselor or school psychologist)`;

export const DysregulatedStudentResponseForm = ({ isOpen, toggle, onSubmitted, response }) => {
  const [dysregulationResponse, setDysregulationResponse] = useState('');

  useEffect(() => {
    setDysregulationResponse(response?.dysregulationResponse || '');
  }, [response, setDysregulationResponse]);

  const submitForm = async () => {
    await authorizedPost(`/api/check-in-responses/${response.checkInResponseId}/dysregulation-response`, dysregulationResponse);
    onSubmitted && onSubmitted();
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Dysregulation Response to {response?.userFullName}
      </ModalHeader>
      <ModalBody>
        <p>{response?.userFullName} checked in with a state of <ResponseLabel response={response?.value} />. Please note your response.</p>
        <Form>
          <FormGroup>
            <Input type="textarea" value={dysregulationResponse} onChange={(e) => setDysregulationResponse(e.target.value)} placeholder={placeholderText} />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={submitForm}>Submit</Button>
        {/* todo - remove? */}
        {' '}
        <Button onClick={toggle}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
}

const DysregulatedStudentForm = ({ isOpen, toggle, onSubmit }) => {
  const [requestedRegulation, setRequestedRegulation] = useState(null);

  const selectedActivityChanged = (e) => {
    if (e?.target?.checked) {
      const newId = e.target.value;
      setRequestedRegulation(newId);
    }
  }

  const submitForm = () => {
    if (onSubmit) onSubmit(availableActivities[requestedRegulation]);
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Dysregulation
      </ModalHeader>
      <ModalBody>
        <p>Looks like you could use a little more regulation today. What can your teacher do to help?</p>
        <Form>
          <FormGroup>
            {availableActivities.map((activity, i) => (
              <FormGroup check key={i}>
                <Input 
                  id={`dysregulation${i}`} 
                  name="dysregulationActivity" 
                  type="radio" 
                  value={i} 
                  onChange={selectedActivityChanged} 
                />
                <Label check for={`dysregulation${i}`}>
                  {activity}
                </Label>
              </FormGroup>
            ))}
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={submitForm}>Submit</Button>
        {/* todo - remove? */}
        <Button onClick={toggle}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
}

export default DysregulatedStudentForm;